import React, { useState, useEffect, useCallback } from 'react';
import {
  Box,
  Container,
  Typography,
  Modal,
  IconButton,
  Fade,
  Zoom,
  Chip,
} from '@mui/material';
import { Close as CloseIcon, NavigateBefore, NavigateNext } from '@mui/icons-material';
import LazyImage from '../components/LazyImage';

interface ProjectImage {
  id: string;
  url: string;
  alt: string;
}

interface ProjectGroup {
  id: string;
  category: string;
  categoryColor: string;
  images: ProjectImage[];
}

const projectGroups: ProjectGroup[] = [
  {
    id: 'ford-torino',
    category: 'FORD TORINO',
    categoryColor: '#912F40',
    images: [
      { id: '1-1', url: '/images/Fordtorino/fordtorino.JPG', alt: 'Ford Torino Main View' },
      { id: '1-2', url: '/images/Fordtorino/fordtorino1.JPG', alt: 'Ford Torino Front' },
      { id: '1-3', url: '/images/Fordtorino/fordtorino2.JPG', alt: 'Ford Torino Side Profile' },
      { id: '1-4', url: '/images/Fordtorino/fordtorino3.JPG', alt: 'Ford Torino Detail' },
      { id: '1-5', url: '/images/Fordtorino/fordtorino56.JPG', alt: 'Ford Torino Rear View' },
    ],
  },
  {
    id: 'black-chevelle',
    category: 'BLACK CHEVELLE',
    categoryColor: '#702632',
    images: [
      { id: '2-1', url: '/images/BlackChevelle/blackchevelle.JPG', alt: 'Black Chevelle Main' },
      { id: '2-2', url: '/images/BlackChevelle/blackchevelle1.JPG', alt: 'Black Chevelle Detail 1' },
      { id: '2-3', url: '/images/BlackChevelle/blackchevelle2.JPG', alt: 'Black Chevelle Detail 2' },
      { id: '2-4', url: '/images/BlackChevelle/blackchevelle3.JPG', alt: 'Black Chevelle Detail 3' },
      { id: '2-5', url: '/images/BlackChevelle/blackchevelle4.JPG', alt: 'Black Chevelle Detail 4' },
      { id: '2-6', url: '/images/BlackChevelle/blackchevelle5.JPG', alt: 'Black Chevelle Detail 5' },
    ],
  },
  {
    id: 'blue-c10',
    category: 'BLUE C10 TRUCK',
    categoryColor: '#40434E',
    images: [
      { id: '3-1', url: '/images/bluec10/bluec10.JPG', alt: 'Blue C10 Truck Main' },
      { id: '3-2', url: '/images/bluec10/bluec101.JPG', alt: 'Blue C10 Detail 1' },
      { id: '3-3', url: '/images/bluec10/bluec102.JPG', alt: 'Blue C10 Detail 2' },
      { id: '3-4', url: '/images/bluec10/c10.JPG', alt: 'C10 Detail' },
    ],
  },
  {
    id: 'baby-blue',
    category: 'BABY BLUE BUILD',
    categoryColor: '#912F40',
    images: [
      { id: '4-1', url: '/images/BabyBlue/babyblue1.jpg', alt: 'Baby Blue Car Main' },
      { id: '4-2', url: '/images/BabyBlue/babyblue2.jpg', alt: 'Baby Blue Car Detail 1' },
      { id: '4-3', url: '/images/BabyBlue/babyblue3.jpg', alt: 'Baby Blue Car Detail 2' },
      { id: '4-4', url: '/images/BabyBlue/babyblue4.jpg', alt: 'Baby Blue Car Detail 3' },
      { id: '4-5', url: '/images/BabyBlue/babyblue5.jpg', alt: 'Baby Blue Car Detail 4' },
      { id: '4-6', url: '/images/BabyBlue/babyblue6.jpg', alt: 'Baby Blue Car Detail 5' },
      { id: '4-7', url: '/images/BabyBlue/babybluebefore.jpg', alt: 'Baby Blue Before 1' },
      { id: '4-8', url: '/images/BabyBlue/babybluebefore1.jpg', alt: 'Baby Blue Before 2' },
      { id: '4-9', url: '/images/BabyBlue/babybluebefore2.jpg', alt: 'Baby Blue Before 3' },
      { id: '4-10', url: '/images/BabyBlue/babybluepaint1.jpg', alt: 'Baby Blue Paint 1' },
      { id: '4-11', url: '/images/BabyBlue/babybluepaint2.jpg', alt: 'Baby Blue Paint 2' },
      { id: '4-12', url: '/images/BabyBlue/babybluepaint3.jpg', alt: 'Baby Blue Paint 3' },
      { id: '4-13', url: '/images/BabyBlue/babybluepaint4.jpg', alt: 'Baby Blue Paint 4' },
      { id: '4-14', url: '/images/BabyBlue/babybluepaint5.jpg', alt: 'Baby Blue Paint 5' },
      { id: '4-15', url: '/images/BabyBlue/babybluepaint6.jpg', alt: 'Baby Blue Paint 6' },
      { id: '4-16', url: '/images/BabyBlue/babybluepaint7.jpg', alt: 'Baby Blue Paint 7' },
    ],
  },
  {
    id: 'red-ford-motor',
    category: 'RED FORD MOTOR',
    categoryColor: '#702632',
    images: [
      { id: '5-1', url: '/images/Redfordtruckmotor/red55fordmotor.JPG', alt: 'Red Ford Motor Main' },
      { id: '5-2', url: '/images/Redfordtruckmotor/DSCF0510.JPG', alt: 'Ford Motor Detail 1' },
      { id: '5-3', url: '/images/Redfordtruckmotor/DSCF0511.JPG', alt: 'Ford Motor Detail 2' },
      { id: '5-4', url: '/images/Redfordtruckmotor/DSCF0512.JPG', alt: 'Ford Motor Detail 3' },
      { id: '5-5', url: '/images/Redfordtruckmotor/DSCF0513.JPG', alt: 'Ford Motor Detail 4' },
      { id: '5-6', url: '/images/Redfordtruckmotor/DSCF0514.JPG', alt: 'Ford Motor Detail 5' },
      { id: '5-7', url: '/images/Redfordtruckmotor/DSCF0515.JPG', alt: 'Ford Motor Detail 6' },
    ],
  },
  {
    id: 'cream-chevelle',
    category: 'CREAM CHEVELLE',
    categoryColor: '#40434E',
    images: [
      { id: '6-1', url: '/images/creamchevelle/creamecchevelle.JPG', alt: 'Cream Chevelle Main' },
      { id: '6-2', url: '/images/creamchevelle/creamechevel3.JPG', alt: 'Cream Chevelle Detail' },
    ],
  },
  {
    id: 'green-chevelle',
    category: 'GREEN CHEVELLE',
    categoryColor: '#912F40',
    images: [
      { id: '7-1', url: '/images/greenchevelle/chevelle.jpg', alt: 'Green Chevelle Main' },
      { id: '7-2', url: '/images/greenchevelle/chevelle1.jpg', alt: 'Green Chevelle Detail' },
    ],
  },
  {
    id: 'lincoln',
    category: 'LINCOLN CLASSIC',
    categoryColor: '#702632',
    images: [
      { id: '8-1', url: '/images/lincoln/lincoln1.JPG', alt: 'Classic Lincoln Main' },
      { id: '8-2', url: '/images/lincoln/lincln2.JPG', alt: 'Lincoln Detail' },
    ],
  },
  {
    id: '48-chevy',
    category: '48 CHEVY',
    categoryColor: '#40434E',
    images: [
      { id: '9-1', url: '/images/48chevy/48chevy.jpg', alt: '1948 Chevy' },
    ],
  },
  {
    id: 'red-monte-carlo',
    category: 'RED MONTE CARLO',
    categoryColor: '#912F40',
    images: [
      { id: '10-1', url: '/images/RedMontecarlo/montecarloredpaint.jpg', alt: 'Red Monte Carlo' },
    ],
  },
  {
    id: 'betty-lou',
    category: 'BETTY LOU',
    categoryColor: '#702632',
    images: [
      { id: '11-1', url: '/images/bettylou.JPG', alt: 'Betty Lou Classic' },
    ],
  },
  {
    id: 'blue-chevelle',
    category: 'BLUE CHEVELLE',
    categoryColor: '#40434E',
    images: [
      { id: '12-1', url: '/images/bluechevelle.JPG', alt: 'Blue Chevelle' },
    ],
  },
  {
    id: 'el-camino',
    category: 'EL CAMINO',
    categoryColor: '#912F40',
    images: [
      { id: '13-1', url: '/images/elcamino.avif', alt: 'El Camino Custom' },
    ],
  },
  {
    id: 'gmc-2500',
    category: 'GMC 2500',
    categoryColor: '#702632',
    images: [
      { id: '14-1', url: '/images/gmc2500.JPG', alt: 'GMC 2500' },
    ],
  },
  {
    id: 'white-camaro',
    category: 'WHITE CAMARO',
    categoryColor: '#40434E',
    images: [
      { id: '15-1', url: '/images/whitecamero2.jpeg', alt: 'White Camaro' },
    ],
  },
];

const Projects: React.FC = () => {
  const [selectedGroup, setSelectedGroup] = useState<ProjectGroup | null>(null);
  const [currentImageIndex, setCurrentImageIndex] = useState<number>(0);
  const [isImageLoaded, setIsImageLoaded] = useState<boolean[]>(Array(projectGroups.length).fill(false));

  const handleNextImage = useCallback(() => {
    if (!selectedGroup) return;
    setCurrentImageIndex((prev) => (prev + 1) % selectedGroup.images.length);
  }, [selectedGroup]);

  const handlePrevImage = useCallback(() => {
    if (!selectedGroup) return;
    setCurrentImageIndex((prev) =>
      prev === 0 ? selectedGroup.images.length - 1 : prev - 1
    );
  }, [selectedGroup]);

  useEffect(() => {
    const handleKeyPress = (e: KeyboardEvent) => {
      if (!selectedGroup) return;

      if (e.key === 'ArrowLeft') {
        handlePrevImage();
      } else if (e.key === 'ArrowRight') {
        handleNextImage();
      } else if (e.key === 'Escape') {
        handleCloseModal();
      }
    };

    window.addEventListener('keydown', handleKeyPress);
    return () => window.removeEventListener('keydown', handleKeyPress);
  }, [selectedGroup, handleNextImage, handlePrevImage]);

  const handleGroupClick = (group: ProjectGroup) => {
    setSelectedGroup(group);
    setCurrentImageIndex(0);
  };

  const handleCloseModal = () => {
    setSelectedGroup(null);
    setCurrentImageIndex(0);
  };

  const handleImageLoad = (index: number) => {
    setIsImageLoaded(prev => {
      const newState = [...prev];
      newState[index] = true;
      return newState;
    });
  };

  const currentImage = selectedGroup ? selectedGroup.images[currentImageIndex] : null;

  return (
    <>
      <Box
        sx={{
          minHeight: '100vh',
          background: 'linear-gradient(135deg, #080705 0%, #40434E 100%)',
          py: 8,
        }}
      >
        <Container maxWidth="xl">
          <Typography
            variant="h2"
            component="h1"
            sx={{
              textAlign: 'center',
              mb: 2,
              color: '#FFFFFA',
              fontWeight: 'bold',
              fontSize: { xs: '2.5rem', md: '3.75rem' },
              textShadow: '2px 2px 4px rgba(0,0,0,0.5)',
              letterSpacing: '0.05em',
            }}
          >
            PROJECT GALLERY
          </Typography>
          <Typography
            variant="h6"
            sx={{
              textAlign: 'center',
              mb: 6,
              color: '#FFFFFA',
              opacity: 0.85,
              fontSize: { xs: '1rem', md: '1.25rem' },
            }}
          >
            Click any image to view full size
          </Typography>

          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: {
                xs: 'repeat(1, 1fr)',
                sm: 'repeat(2, 1fr)',
                md: 'repeat(3, 1fr)',
                lg: 'repeat(4, 1fr)',
              },
              gap: { xs: 2, sm: 3, md: 4 },
              maxWidth: '1600px',
              mx: 'auto',
            }}
          >
            {projectGroups.map((group, index) => (
              <Zoom
                key={group.id}
                in={isImageLoaded[index]}
                timeout={300}
                style={{
                  transitionDelay: '0ms',
                }}
              >
                <Box
                  onClick={() => handleGroupClick(group)}
                  sx={{
                    position: 'relative',
                    cursor: 'pointer',
                    overflow: 'hidden',
                    borderRadius: 3,
                    bgcolor: 'rgba(255, 255, 250, 0.05)',
                    border: '1px solid rgba(255, 255, 250, 0.1)',
                    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                    aspectRatio: '4 / 3',
                    '&:hover': {
                      transform: 'translateY(-8px) scale(1.02)',
                      boxShadow: `0 20px 40px rgba(145, 47, 64, 0.3),
                                 0 0 0 1px rgba(145, 47, 64, 0.2)`,
                      zIndex: 10,
                      '& .image-overlay': {
                        opacity: 1,
                      },
                      '& .image-content': {
                        transform: 'scale(1.1)',
                      },
                      '& .category-chip': {
                        transform: 'translateY(0)',
                        opacity: 1,
                      },
                    },
                  }}
                >
                  <Box
                    className="image-content"
                    sx={{
                      width: '100%',
                      height: '100%',
                      transition: 'transform 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
                    }}
                  >
                    <LazyImage
                      src={group.images[0].url}
                      alt={group.images[0].alt}
                      width="100%"
                      height="100%"
                      objectFit="cover"
                      onLoad={() => handleImageLoad(index)}
                    />
                  </Box>

                  <Box
                    className="image-overlay"
                    sx={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      background: 'linear-gradient(180deg, rgba(0,0,0,0.1) 0%, rgba(0,0,0,0.6) 100%)',
                      opacity: 0,
                      transition: 'opacity 0.3s ease',
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'flex-end',
                      p: 2,
                    }}
                  />

                  <Chip
                    label={group.category}
                    className="category-chip"
                    size="small"
                    sx={{
                      position: 'absolute',
                      top: 12,
                      left: 12,
                      bgcolor: group.categoryColor,
                      color: '#FFFFFA',
                      fontWeight: 'bold',
                      fontSize: '0.7rem',
                      transform: 'translateY(-60px)',
                      opacity: 0,
                      transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                      boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
                      letterSpacing: '0.05em',
                    }}
                  />
                  {group.images.length > 1 && (
                    <Chip
                      label={`${group.images.length} photos`}
                      size="small"
                      sx={{
                        position: 'absolute',
                        bottom: 12,
                        right: 12,
                        bgcolor: 'rgba(0, 0, 0, 0.7)',
                        color: '#FFFFFA',
                        fontWeight: 'bold',
                        fontSize: '0.7rem',
                        backdropFilter: 'blur(4px)',
                      }}
                    />
                  )}
                </Box>
              </Zoom>
            ))}
          </Box>
        </Container>
      </Box>

      <Modal
        open={!!selectedGroup}
        onClose={handleCloseModal}
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backdropFilter: 'blur(8px)',
        }}
        closeAfterTransition
      >
        <Fade in={!!selectedGroup} timeout={250}>
          <Box
            sx={{
              outline: 'none',
              maxWidth: '95vw',
              maxHeight: '95vh',
              bgcolor: 'rgba(0, 0, 0, 0.95)',
              borderRadius: 3,
              position: 'relative',
              display: 'flex',
              flexDirection: 'column',
              overflow: 'hidden',
              boxShadow: '0 24px 48px rgba(0,0,0,0.5)',
              border: '1px solid rgba(145, 47, 64, 0.3)',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                p: 3,
                borderBottom: '1px solid rgba(255, 255, 250, 0.15)',
                background: 'linear-gradient(180deg, rgba(0,0,0,0.8) 0%, rgba(0,0,0,0.4) 100%)',
              }}
            >
              <Box>
                <Chip
                  label={selectedGroup?.category}
                  size="small"
                  sx={{
                    bgcolor: selectedGroup?.categoryColor,
                    color: '#FFFFFA',
                    fontWeight: 'bold',
                    fontSize: '0.7rem',
                  }}
                />
              </Box>
              <IconButton
                onClick={handleCloseModal}
                sx={{
                  color: '#FFFFFA',
                  bgcolor: 'rgba(145, 47, 64, 0.2)',
                  '&:hover': {
                    bgcolor: 'rgba(145, 47, 64, 0.4)',
                  },
                }}
              >
                <CloseIcon />
              </IconButton>
            </Box>

            {currentImage && selectedGroup && (
              <Box
                sx={{
                  position: 'relative',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  minHeight: 400,
                  maxHeight: '70vh',
                  flex: 1,
                  bgcolor: '#080705',
                }}
              >
                {selectedGroup.images.length > 1 && (
                  <IconButton
                    onClick={handlePrevImage}
                    sx={{
                      position: 'absolute',
                      left: 20,
                      zIndex: 2,
                      color: '#FFFFFA',
                      bgcolor: 'rgba(0, 0, 0, 0.6)',
                      backdropFilter: 'blur(4px)',
                      '&:hover': {
                        bgcolor: 'rgba(145, 47, 64, 0.8)',
                        transform: 'scale(1.1)',
                      },
                      transition: 'all 0.3s ease',
                    }}
                  >
                    <NavigateBefore fontSize="large" />
                  </IconButton>
                )}

                <Box
                  sx={{
                    maxWidth: '100%',
                    maxHeight: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    p: 4,
                  }}
                >
                  <img
                    src={currentImage.url}
                    alt={currentImage.alt}
                    style={{
                      maxWidth: '100%',
                      maxHeight: '100%',
                      objectFit: 'contain',
                      borderRadius: '8px',
                    }}
                  />
                </Box>

                {selectedGroup.images.length > 1 && (
                  <IconButton
                    onClick={handleNextImage}
                    sx={{
                      position: 'absolute',
                      right: 20,
                      zIndex: 2,
                      color: '#FFFFFA',
                      bgcolor: 'rgba(0, 0, 0, 0.6)',
                      backdropFilter: 'blur(4px)',
                      '&:hover': {
                        bgcolor: 'rgba(145, 47, 64, 0.8)',
                        transform: 'scale(1.1)',
                      },
                      transition: 'all 0.3s ease',
                    }}
                  >
                    <NavigateNext fontSize="large" />
                  </IconButton>
                )}
              </Box>
            )}

            {currentImage && selectedGroup && (
              <Box
                sx={{
                  p: 2,
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  gap: 2,
                  borderTop: '1px solid rgba(255, 255, 250, 0.15)',
                  background: 'linear-gradient(0deg, rgba(0,0,0,0.8) 0%, rgba(0,0,0,0.4) 100%)',
                }}
              >
                <Typography
                  variant="body2"
                  sx={{
                    color: '#FFFFFA',
                    opacity: 0.7,
                    fontWeight: 500,
                  }}
                >
                  {currentImageIndex + 1} of {selectedGroup.images.length}
                </Typography>
                {selectedGroup.images.length > 1 && (
                  <Typography
                    variant="caption"
                    sx={{
                      color: '#FFFFFA',
                      opacity: 0.5,
                    }}
                  >
                    Use arrow keys to navigate
                  </Typography>
                )}
              </Box>
            )}
          </Box>
        </Fade>
      </Modal>
    </>
  );
};

export default Projects;